import React, { useState, useEffect } from 'react'
import { Panel, Button, Input, ControlLabel, Message } from 'rsuite'
import { useParams, useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import { startLoading, doneLoading } from '../../utils/loading'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { updateSignContract } from '../../redux/actions/contract'
import pathname from '../../constants/pathname'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'

export default function OfferAuthorizedSignatoryStaffPanel(props) {
  const { showCommandButton, schema, isEdit, onChangeIsEdit } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleCallService = async () => {
    setShowConfirm(false)
    let request = {
      projectVersionId: projectId,
      userId: '',
      value: memo,
    }

    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateSignContract(request, projectId)

      if (response.success) {
        //success jump to new page
        setShowConfirm(false)
        setIsError(false)
        doneLoading()
        setIsLoading(false)
        sessionStorage.setItem('projectId', response.model.projectVersionId)
        sessionStorage.setItem('param', '')
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else {
        setShowConfirm(false)
        setIsError(response.errorMessage)
      }

      // if (response.success) {
      //   //success jump to new page
      //   setIsError(false)
      //   setShowConfirm(false)
      //   doneLoading()
      //   setIsLoading(false)
      //   return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
      // }
      // setShowConfirm(false)
    } catch (e) {
      setShowConfirm(false)
      console.log(e?.response?.data)
      if (e?.response?.data) {
        setIsError(e?.response?.data?.errorMessage)
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)
    setMemo(data.note)
    setShowConfirm(true)
  }

  return (
    <div>
      <Panel header={schema?.header} collapsible defaultExpanded bordered shaded>
        <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
        <ErrorMessage error={errors[schema.note.name]} />
        <br />
        <Input
          name={schema.note.name}
          inputRef={register(isValidators(schema.note.validators))}
          rows={3}
          placeholder={schema.note.label}
          componentClass="textarea"
        />
        <hr />
        {isError && <Message showIcon type="error" description={isError} />}

       
        <ApproverList
          approveType={11}
          projectversionId={projectId}
          style={{ marginLeft: 10 }}
          buttontext={'ตรวจสอบสายอนุมัติและ' + schema.buttonText}
          isLoading={isLoading}
          fetchButton={(disabled) =>
            <Button
              style={{ width: 'auto', marginBottom: 10}}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={disabled || isLoading}
            >
              {schema.buttonText}
            </Button>
          }
        />
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
